import moment from 'moment';
import {
  AecoSignWebService,
  RestfulAecoSignWebService
} from 'ws/AecoSignWebService';

export interface AecoSignManager {
  getFullSpaceIds(
    channelGroupId: number,
    startDate: string,
    endDate: string,
    testMode: boolean,
    campaignId?: number | null
  ): Promise<Set<string>>;
}

/**
 * 電子紙（元太 AecoSign）的機台名額查詢。
 *
 * 廠商限制一台裝置在一個 daypart 最多綁 10 個活動；後端是逐日判定，走期內任一天滿了
 * 就算滿（ECOPD-5616）。
 */
export class DefaultAecoSignManager implements AecoSignManager {
  constructor(
    private webService: AecoSignWebService = new RestfulAecoSignWebService()
  ) {}

  /**
   * @param startDate 走期起日，`yyyy-MM-dd` 或任何 moment 讀得懂的字串
   * @param endDate 走期迄日
   * @returns 已滿的 spaceId 集合。走期不完整或顛倒時回空集合 ——
   *   後端對顛倒的走期回 400（刻意的，見該端點註解），使用者在表單上把日期改到一半
   *   本來就會短暫出現顛倒，不該讓它變成一個錯誤彈窗。
   */
  async getFullSpaceIds(
    channelGroupId: number,
    startDate: string,
    endDate: string,
    testMode: boolean,
    campaignId?: number | null
  ): Promise<Set<string>> {
    const start = moment(startDate);
    const end = moment(endDate);
    if (!start.isValid() || !end.isValid() || end.isBefore(start, 'day')) {
      return new Set();
    }
    const records = await this.webService.getFullSpaceIds(
      channelGroupId,
      start.format('YYYY-MM-DD'),
      end.format('YYYY-MM-DD'),
      testMode,
      campaignId
    );
    return new Set(records);
  }
}
